export const SORTABLE_CLASS = 'sortable-item';
export const HANDLE_CLASS = 'sortable-handle';
